import UnauthenticatedLayout from '@/modules/layout/unauthenticated-layout.component';
import LoginPage from '@/modules/login/login.component';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const Home = () => <LoginPage />;
Home.title = 'Login';

Home.getLayout = (page) => <UnauthenticatedLayout>{page}</UnauthenticatedLayout>;

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default Home;
